import React from 'react';
import { useTranslation } from 'react-i18next';

import { Hidden, Link, Typography } from '@mui/material';
import { Container } from 'component/Container/Container';
import { HeaderPure } from 'component/Header/HeaderPure';
import { LangNamespaceEnum } from 'shared/enums/LangNamespaceEnum';
import { PageContainer } from 'component/PageContainer/PageContainer';
import { Button } from 'component/Button/Button';

import { Root, Body } from './NetworkErrorPage.s';

export const NetworkErrorPage: React.VFC = () => {
  const { t } = useTranslation(LangNamespaceEnum.SURVEY_UI_PAGES);

  const onClickHandler = () => {
    const prevUrl = localStorage.getItem('prevUrl');

    if (prevUrl) {
      window.location.href = prevUrl;
    } else {
      window.history.back();
    }
  };

  return (
    <PageContainer
      headerElement={
        <>
          <Hidden lgDown>
            <HeaderPure shouldBePlacedAbsolutely />
          </Hidden>
          <Hidden lgUp>
            <Container>
              <HeaderPure shouldBePlacedAbsolutely />
            </Container>
          </Hidden>
        </>
      }
    >
      <Root data-testid="notFoundPage">
        <Body>
          <Typography component="h1" variant="h3">
            {t('NetworkErrorPage.title')}
          </Typography>

          <Typography mt={2} mb={2}>
            {t('NetworkErrorPage.description')}{' '}
            <Link href="mailto:support@workbuzz.com" variant="h6" target="_blank">
              support@workbuzz.com
            </Link>
          </Typography>

          <Button onClick={onClickHandler}>{t('RefreshButton.refreshPage')}</Button>
        </Body>
      </Root>
    </PageContainer>
  );
};
